<template>
  <audio-player
    :audio-url="audioUrl"
    :block-name="blockName"
    :has-volume="false"
    :has-progress-thumb="false"
    :reset-on-end="true"
    :has-time="hasTime"
    :event-name="eventName"
    :event-payload="eventPayload"
    @play="onPlay"
    @pause="onPause"
    :theme="theme"
    :play-button-classes="playButtonClasses"
    ref="player"
  />
</template>

<script>
import notify from "@/utils/notify"
import api from "@/api"
import AudioPlayer from "@/shared/audio-player/audio-player"

export default {
  name: "SampleAudioPlayer",
  components: { AudioPlayer },
  props: {
    bookSlug: { type: String, default: null },
    blockName: { type: String, default: null },
    label: { type: String, default: null },
    hasTime: { type: Boolean, default: null },
    eventName: { type: String, default: null },
    eventPayload: { type: String, default: null },
    theme: { type: String, default: null },
    playButtonClasses: {
      type: String,
      default: ""
    }
  },

  data() {
    return { audioUrl: null }
  },

  mounted() {
    api.books
      .sample(this.bookSlug)
      .then((data) => {
        this.audioUrl = data.preview_url
      })
      .catch((err) => {
        notify(err)
      })
  },

  methods: {
    play() {
      this.$refs.player.play()
    },

    pause() {
      this.$refs.player.pause()
    },

    onPlay() {
      this.$emit("play")
    },

    onPause() {
      this.$emit("pause")
    }
  }
}
</script>
